import $ from "jquery";
window.$ = window.jQuery = $;
import Collapse from 'bootstrap/js/dist/collapse';

$(document).ready(function(){
	const $header=$('#header,#mobileHeader');
	const $mobileHeader=$('#mobileHeader');
	const $body=$('#body');
	$body.css('margin-top',$header.outerHeight());
	if($mobileHeader.is(':visible') && !$mobileHeader.hasClass('traditional-2-mobile') && !$mobileHeader.hasClass('contemporary-1-mobile')){
		$body.css('margin-top',$mobileHeader.outerHeight());
	}
	function isMobile(){
		let check = false;
		(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
		return check;
	}
	const mobile=isMobile();
	if(mobile){
		$body.addClass('mobile');
	}

	$('.photo-gallery-slider,.editorial-gallery-slider').owlCarousel({
		dots: false,
		nav:true,
		loop:true,
		items:1,
		animateIn:"fadeIn",
		animateOut:"fadeOut",
		navText:['<svg width="8" height="19" viewBox="0 0 8 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.6016 0.171837C4.40634 -0.0234241 4.08976 -0.0234242 3.8945 0.171837L0.712514 3.35382C0.517252 3.54908 0.517252 3.86566 0.712514 4.06092C0.907776 4.25619 1.22436 4.25619 1.41962 4.06092L4.24805 1.2325L7.07648 4.06092C7.27174 4.25619 7.58832 4.25619 7.78358 4.06092C7.97884 3.86566 7.97884 3.54908 7.78358 3.35382L4.6016 0.171837ZM4.74805 18.0254L4.74805 0.525391L3.74805 0.525391L3.74805 18.0254L4.74805 18.0254Z" fill="#050058"/></svg>','<svg width="8" height="19" viewBox="0 0 8 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.89449 18.7403C4.08976 18.9355 4.40634 18.9355 4.6016 18.7403L7.78358 15.5583C7.97884 15.363 7.97884 15.0464 7.78358 14.8512C7.58832 14.6559 7.27174 14.6559 7.07647 14.8512L4.24805 17.6796L1.41962 14.8512C1.22436 14.6559 0.907775 14.6559 0.712513 14.8512C0.517251 15.0464 0.517251 15.363 0.712513 15.5583L3.89449 18.7403ZM3.74805 0.886719L3.74805 18.3867H4.74805L4.74805 0.886719L3.74805 0.886719Z" fill="#050058"/></svg>'],
		onChange: function(evnt) {
			changeSlideNum(evnt)
		}
	});

	$('.animated-photo-gallery-slider').owlCarousel({
		dots: false,
		nav:true,
		loop:true,
		items:1,
		navText:['<svg width="8" height="19" viewBox="0 0 8 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.6016 0.171837C4.40634 -0.0234241 4.08976 -0.0234242 3.8945 0.171837L0.712514 3.35382C0.517252 3.54908 0.517252 3.86566 0.712514 4.06092C0.907776 4.25619 1.22436 4.25619 1.41962 4.06092L4.24805 1.2325L7.07648 4.06092C7.27174 4.25619 7.58832 4.25619 7.78358 4.06092C7.97884 3.86566 7.97884 3.54908 7.78358 3.35382L4.6016 0.171837ZM4.74805 18.0254L4.74805 0.525391L3.74805 0.525391L3.74805 18.0254L4.74805 18.0254Z" fill="#050058"/></svg>','<svg width="8" height="19" viewBox="0 0 8 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.89449 18.7403C4.08976 18.9355 4.40634 18.9355 4.6016 18.7403L7.78358 15.5583C7.97884 15.363 7.97884 15.0464 7.78358 14.8512C7.58832 14.6559 7.27174 14.6559 7.07647 14.8512L4.24805 17.6796L1.41962 14.8512C1.22436 14.6559 0.907775 14.6559 0.712513 14.8512C0.517251 15.0464 0.517251 15.363 0.712513 15.5583L3.89449 18.7403ZM3.74805 0.886719L3.74805 18.3867H4.74805L4.74805 0.886719L3.74805 0.886719Z" fill="#050058"/></svg>'],
		onTranslated:function(evnt){
			hideNonActiveSlides(evnt);
		},
		onInitialized:function(evnt){
			hideNonActiveSlides(evnt);
		},
		onChange: function(evnt) {
			changeSlideNum(evnt)
		}
	});

	function changeSlideNum(evnt) {
		let totalSlides=evnt.item.count;
		const index = (evnt.property.value - Math.ceil(totalSlides / 2)) % totalSlides || 0;
		var currentSlideNum=index+1;
		if(currentSlideNum<=0){
			currentSlideNum=totalSlides;
		}
		if(currentSlideNum<10){
			currentSlideNum='0'+currentSlideNum;
		}
		if(totalSlides<10){
			totalSlides='0'+totalSlides;
		}
		$(evnt.currentTarget).closest('.inner-container').find('.counter').html(currentSlideNum+"/"+totalSlides);
	}

	function hideNonActiveSlides(evnt) {
		const $slider=$(evnt.currentTarget);
		$slider.find('.not-visible').removeClass('not-visible');
		$slider.find('.active').prev().prevAll().addClass('not-visible');
		$slider.find('.active').next().nextAll().addClass('not-visible');
		$slider.closest('.inner-container').find('.caption').html($slider.find('.active figcaption').text());
	}

	$('.common-video-carousel').owlCarousel({
		items:1,
		dots: false,
		video:true,
		mouseDrag:false,
		touchDrag:false,
		pullDrag:false,
		nav:false,
		freeDrag:false,
		onInitialized:function(event){
			// matchVideoHeights($(event.target).closest('.video-module'));
		},
		onResized:function(event){
			// matchVideoHeights($(event.target).closest('.video-module'));
		}
	});

	$('.custom-ckeditor-document').each(function(i,elem){
		const $this=$(elem);
		$this.html('<i class="v-middle"><svg width="26" height="32" viewBox="0 0 26 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.305 1.6543H4.75671C3.99101 1.6543 3.25667 1.95847 2.71524 2.4999C2.1738 3.04134 1.86963 3.77568 1.86963 4.54138V27.638C1.86963 28.4037 2.1738 29.1381 2.71524 29.6795C3.25667 30.221 3.99101 30.5251 4.75671 30.5251H22.0792C22.8449 30.5251 23.5793 30.221 24.1207 29.6795C24.6621 29.1381 24.9663 28.4037 24.9663 27.638V10.3155L16.305 1.6543Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.3052 1.6543V10.3155H24.9664" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.1919 17.5332H7.64355" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.1919 23.3076H7.64355" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.5306 11.7593H9.0871H7.64355" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></i><span class="v-middle">'+$this.text()+'</span>').wrapAll('<div class="p0 document-downloads"></div>');
	});

	$('.custom-ckeditor-button').each(function(i,elem){
		const $this=$(elem);
		$this.html('<i class="v-middle"><svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.39635 14.2922L0.985352 12.8782L6.27435 7.58523L0.985352 2.29223L2.40035 0.878227L7.68535 6.17123C8.06029 6.54628 8.27093 7.0549 8.27093 7.58523C8.27093 8.11556 8.06029 8.62417 7.68535 8.99923L2.39635 14.2922Z" fill="white"></path></svg></i><span class="v-middle">'+$this.text()+'</span>');
	});

	$('.redactor-styles table').each(function(i,elem){
		$(elem).wrap('<div class="table-responsive"></div>');
	});
	
	let headerHeight=$header.outerHeight();
	if($mobileHeader.is(':visible')){
		headerHeight=$mobileHeader.outerHeight();
	}

	$('.anchorLink').on('click',function(){
		const $this=$(this);
		$('html,body').animate({'scrollTop':$(''+$this.attr('href')).offset().top-headerHeight-10});
	});

	$('.accordion-button').on('click',function(){
		const $this=$(this);
		if(!$this.hasClass('collapsed') && ($this.closest('.accordion-item').prevAll().find('.accordion-collapse.collapsing').length || $this.closest('.accordion-item').prevAll().find('.accordion-collapse.show').length)){
			setTimeout(function() {
				$('html,body').animate({'scrollTop':$this.offset().top-headerHeight-10});
			}, 500);
		}
	});

	var $window=$(window);
	var windowHeight = $window.height();
	$window.resize(function () {
		windowHeight = $window.height();
	});
	$.fn.parallax = function(xscrollTop, speedFactor, outerHeight) {
		var $this = $(this);
		var getHeight;
		var firstTop;
		var paddingTop = 0;
		if(mobile){
			$this.addClass('mobile-parallax');
		}else{
			return false;
		}
    	//get the starting scrollTopition of each element to have parallax applied to it    
    	$this.each(function(){
    		firstTop = $this.offset().top;
    	});

    	if (outerHeight) {
    		getHeight = function(jqo) {
    			return jqo.outerHeight(true);
    		};
    	} else {
    		getHeight = function(jqo) {
    			return jqo.height();
    		};
    	}

    	// setup defaults if arguments aren't specified
    	if (arguments.length < 1 || xscrollTop === null) xscrollTop = "50%";
    	if (arguments.length < 2 || speedFactor === null) speedFactor = 0.1;
    	if (arguments.length < 3 || outerHeight === null) outerHeight = true;

    	// function to be called whenever the window is scrolled or resized
    	function update(){
    		var scrollTop = $window.scrollTop();        

    		$this.each(function(){
    			var $element = $(this);
    			var offsetTop = $element.offset().top;
    			var elementHeight = getHeight($element);

        		// Check if totally above or totally below viewport
        		if (offsetTop + elementHeight < scrollTop || offsetTop > scrollTop + windowHeight) {
        			return;
        		}
        		var scrollStartPosition=offsetTop;
        		var scrollEndPosition=offsetTop+elementHeight+windowHeight;
        		if(!offsetTop){
        			windowHeight=0;
        		}
        		$this.css('backgroundPosition', xscrollTop + " " + Math.round(((1-(scrollEndPosition - scrollTop-windowHeight)/(scrollEndPosition-scrollStartPosition))*100)) + "%");
        	});
    	}   

    	$window.bind('scroll', update).resize(update);
    	update();
    };

    $('#mobileHeader .has-sub-menu>a').on('click',function(e){
    	$(this).parent().toggleClass('active');
    });

    $('#openMobileQuicklinks').on('click',function(e){
    	$mobileHeader.addClass('menu-opened quicklinks-opened');
    });
    $('#openMobileTranslate').on('click',function(e){
    	$mobileHeader.toggleClass('menu-opened');

    	setTimeout(function() {
    		$mobileHeader.find('.google-translate-mobile').trigger('click');
    	}, 100);
    });

    $('#toggleMobileMenu').on('click',function(e){
    	$mobileHeader.toggleClass('menu-opened');
    	$mobileHeader.removeClass('quicklinks-opened');
    }); 
    $('#backToMenu').on('click',function(e){
    	$mobileHeader.removeClass('quicklinks-opened');
    });


    $('.parallax-scroll').parallax();

    $('.google-translate,.google-translate-mobile').on('click',function(e){
    	e.stopPropagation();
    	var $this=$(this);
    	$this.find('.dropdown-menu').show();
    });
    const $googleTranslateDropdowns=$('.google-translate .dropdown-menu,.google-translate-mobile .dropdown-menu');
    $(window).click(function() {
    	$googleTranslateDropdowns.hide();
    });

    if($(window).scrollTop()>20){
    	$header.addClass('scrolled');
    }
    $('#openSearch,#openSearch2,#openSearchMobile,#openSearchMobile2').on('click',function(){
    	const $this=$(this);
    	$this.closest('li').find('form').show();
    	$this.closest('li').find('form input').focus();
    });
    const $container = $("#searchForm,#searchForm2,#searchFormMobile,#searchFormMobile2,#header .sub-menu");
    $(document).mouseup(function(e){
    	if (!$container.is(e.target) && $container.has(e.target).length === 0) 
    	{
    		$container.hide();
    		$header.find('.open-sub-menu').removeClass('open-sub-menu');
    	}
    });
    const $fullMenu=$('#full-menu');
    const $quicklinks=$('#quicklinks');
    $('#closeMenu').on('click',function(){
    	$fullMenu.fadeOut();
    	$body.removeClass('over-hidden');
    });

    $('#openMenu').on('click',function(){
    	$fullMenu.fadeIn();
    	$body.addClass('over-hidden');
    });

    $('#openQuicklinks').on('click',function(){
    	$quicklinks.fadeIn();
    	$body.addClass('over-hidden');
    });

    $('#closeQuicklinks').on('click',function(){
    	$quicklinks.fadeOut();
    	$body.removeClass('over-hidden');
    });

    $('#full-menu .has-sub-menu').on('click',function(){
    	const $this=$(this);
    	$this.addClass('active').siblings().removeClass('active');
    });
    $('#header .has-sub-menu>a').on('click',function(){
    	const $this=$(this).parent();
    	$this.find('.sub-menu').show();
    	$this.addClass('open-sub-menu').siblings().removeClass('open-sub-menu').find('.sub-menu').hide();
    });

    $('.owl-video-play-icon').html('<span class="play-btn-outer"><i><svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.3776 11.5488C22.0306 11.9362 22.0306 12.8814 21.3776 13.2688L8.7193 20.7791C8.0527 21.1746 7.20904 20.6942 7.20904 19.9191L7.20904 4.89856C7.20904 4.12347 8.0527 3.64304 8.7193 4.03854L21.3776 11.5488Z" fill="white"/></svg></i><span>Play</span></span>');


    var lastScrollTop = 0;

	// element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
	window.addEventListener("scroll", function(){ // or window.addEventListener("scroll"....
	   var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
	   if (st > lastScrollTop) {
	   	$header.addClass('scrolled-down');
	   } else if (st < lastScrollTop) {
	   	$header.removeClass('scrolled-down');
	   } // else was horizontal scroll
	   if(st>20){
	   	$header.addClass('scrolled');
	   }else{
	   	$header.removeClass('scrolled');
	   }
	   lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	 }, false);

});